<div class="header" >
    <h1 class="title">  Summer Consulting Internship Program for Undergraduates</h1>
</div>
<div class="logo">
    <img src="/assets/images/tn-logo.png" alt="">
</div>
<div class="subtitle">
    <p>  Undergraduate Junior or Senior in a Business Administration or Engineering Major</p>
</div>
<div class="content">
    <div class="left">

        <form class="" autocomplete="off"  [formGroup]="appForm" *ngIf="currentPage==1">

            <h4>General Information</h4>

            <div class="" style="margin-top: 2em; margin-bottom: 2em;">
                
                <div class="form-row">
                    <div class="col-4">
                        <div class="form-group row">
                            <label for="" class="col-sm-5 col-form-label">First name:</label>
                            <div class="col-sm-7">
                            <input type="text" class="form-control" formControlName="firstName">
                            <small class="p-error">
                                <span *ngIf="isFieldValid('firstName')"> This field is required.</span>
                            </small>
                            </div>
                            
                        </div>
                        
                    </div>
                    <div class="col-4">
                        <div class="form-group row">
                            <label for="" class="col-sm-5 col-form-label">Middle name:</label>
                            <div class="col-sm-7">
                                <input type="text" class="form-control" formControlName="middleName">
                                <small class="p-error">
                                    <span *ngIf="isFieldValid('middleName')"> This field is required.</span>
                                </small>
                            </div>
                        </div>
                    </div>
                    <div class="col-4">
                        <div class="form-group row">
                            <label for="" class="col-sm-5 col-form-label">Last name:</label>
                            <div class="col-sm-7">
                                <input type="text" class="form-control" formControlName="lastName">
                                <small class="p-error">
                                    <span *ngIf="isFieldValid('lastName')"> This field is required.</span>
                                </small>
                            </div>
                        </div>
                    </div>
                </div>
        
                <div class="form-row">
                    <div class="col-4">
                        <div class="form-group row">
                            <label for="" class="col-sm-4 col-form-label">Phone:</label>
                            <div class="col-sm-8">
                            <input type="text" class="form-control" formControlName="phone">
                            <small class="p-error">
                                <span *ngIf="isFieldValid('phone')"> This field is required.</span>
                            </small>
                            </div>
                        </div>
                    </div>
                    <div class="col-8">
                        <div class="form-group row">
                            <label for="" class="col-sm-2 col-form-label">Email:</label>
                            <div class="col-sm-10">
                            <input type="email" class="form-control" formControlName="email">
                            <small class="p-error">
                                <span *ngIf="isFieldValid('email')"> Invalid email.</span>
                            </small>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="form-group row">
                    <label for="" class="col-sm-2 col-form-label">Address Line 1:</label>
                    <div class="col-sm-10">
                    <input type="text" class="form-control" formControlName="addressLine1">
                    <small class="p-error">
                        <span *ngIf="isFieldValid('addressLine1')"> This field is required.</span>
                    </small>
                    </div>
                </div>
                <div class="form-group row">
                    <label for="" class="col-sm-2 col-form-label">Address Line 2:</label>
                    <div class="col-sm-10">
                    <input type="text" class="form-control" formControlName="addressLine2">
                    <small class="p-error">
                        <span *ngIf="isFieldValid('addressLine2')"> This field is required.</span>
                    </small>
                    </div>
                </div>

                <div class="form-row">
                    <div class="col-4">
                        <div class="form-group row">
                            <label for="" class="col-sm-4 col-form-label">City:</label>
                            <div class="col-sm-8">
                            <input type="text" class="form-control" formControlName="city">
                            <small class="p-error">
                                <span *ngIf="isFieldValid('city')"> This field is required.</span>
                            </small>
                            </div>
                        </div>
                    </div>
                    <div class="col-4">
                        <div class="form-group row">
                            <label for="" class="col-sm-4 col-form-label">State:</label>
                            <div class="col-sm-8">
                            <input type="text" class="form-control" formControlName="state">
                            <small class="p-error">
                                <span *ngIf="isFieldValid('state')"> This field is required.</span>
                            </small>
                            </div>
                        </div>
                    </div>
                    <div class="col-4">
                        <div class="form-group row">
                            <label for="" class="col-sm-4 col-form-label">Postal:</label>
                            <div class="col-sm-8">
                            <input type="text" class="form-control" formControlName="postal">
                            <small class="p-error">
                                <span *ngIf="isFieldValid('postal')"> This field is required.</span>
                            </small>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <h4>College Information</h4>

            <div class="" style="margin-top: 2em;">

                <div class="form-row">
                    <div class="col-3">
                        <div class="form-group row">
                            <label for="" class="col-sm-4 col-form-label">College:</label>
                            <div class="col-sm-8">
                            <input type="text" class="form-control" formControlName="college">
                            <small class="p-error">
                                <span *ngIf="isFieldValid('college')"> This field is required.</span>
                            </small>
                            </div>
                        </div>
                    </div>
                    <div class="col-6">
                        <div class="form-group row">
                            <label for="" class="col-sm-5 col-form-label">Major/Concentration:</label>
                            <div class="col-sm-7">
                            <input type="text" class="form-control" formControlName="majorConcentration">
                            <small class="p-error">
                                <span *ngIf="isFieldValid('majorConcentration')"> This field is required.</span>
                            </small>
                            </div>
                        </div>
                    </div>
                    <div class="col-3">
                        <div class="form-group row">
                            <label for="" class="col-sm-4 col-form-label">Year:</label>
                            <div class="col-sm-8">
                                <select formControlName="yearId" class="form-control">
                                    <option *ngFor="let item of yearList" value="{{item.id}}">{{item.name}}</option>
                                </select>
                                <small class="p-error">
                                    <span *ngIf="isFieldValid('yearId')"> This field is required.</span>
                                </small>
                            </div>
                        </div>
                    </div>
                </div>
    
                <div class="form-row">
                    <div class="col-5">
                        <div class="form-group row">
                            <label for="" class="col-sm-5 col-form-label">College GPA:</label>
                            <div class="col-sm-7">
                            <input type="text" class="form-control" formControlName="collegeGpa">
                            <small class="p-error">
                                <span *ngIf="isFieldValid('collegeGpa')"> This field is required.</span>
                            </small>
                            </div>
                        </div>
                    </div>
                
                    <div class="col-6">
                        <div class="form-group row">
                            <label for="" class="col-sm-6 col-form-label">Expected Year of Graduation:</label>
                            <div class="col-sm-6">
                                <select formControlName="expectedYearOfGraduationId" class="form-control">
                                    <option *ngFor="let item of expectedYearOfGraduationList" value="{{item.id}}">{{item.name}}</option>
                                </select>
                                <small class="p-error">
                                    <span *ngIf="isFieldValid('expectedYearOfGraduationId')"> This field is required.</span>
                                </small>
                            </div>
                        </div>
                    </div>
                </div>
    
            </div>

            <button type="button" class="btn btn-light" (click)="next(currentPage)" style="width: 7em; font-weight: 500;">Next</button>
        </form>

        <div class="" *ngIf="currentPage==2">

            <h4>Essay</h4>
            <p>Write an essay of no more than 650 words on one of the following topics:</p>
            <ul>
                <li>"Economic development of Puerto Rico and the role of private companies in contributing to it.”</li>
                <li>“The contribution of professional development of employees to the growth of a country.”</li>
                <li>"The role of innovation in the sustainable development of a country"</li>
            </ul>

            <div class="form-group">
                <textarea class="form-control" name="essay" [(ngModel)]="essay" rows="15"></textarea>
                <small class="p-error">
                    <span > {{essayError}}</span>
                </small>
            </div>

            <button type="button" class="btn btn-light" (click)="back(currentPage)" style="width: 7em; font-weight: 500; margin-right: 1em;">Back</button>
            <button type="button" class="btn btn-light" (click)="next(currentPage)" style="width: 7em; font-weight: 500;">Next</button>

        </div>

        <div class="" *ngIf="currentPage==3">

            <p>Resume <span style="color: red;">*</span></p>
            <label for="file1" class="file-upload-label">Attach resume</label>
            <input type="file" id="file1" (change)="onResumeFileSelected($event)" multiple>
            <ul>
                <span style="display: block; font-size: .9em;" *ngFor="let item of resumeFiles">&#10003; {{item.name}}</span>
            </ul>
            <br> 

            <p>College Transcripts <span style="color: red;">*</span></p>
            <label for="file2" class="file-upload-label">Attach Transcripts</label>
            <input type="file" id="file2" (change)="onTranscriptFileSelected($event)" multiple>
            <ul>
                <span style="display: block; font-size: .9em;" *ngFor="let item of transcriptFiles">&#10003; {{item.name}}</span>
            </ul>
            <br> 
            <br> 

            <button type="button"
                (click)="sendApplication()"
                class="btn btn-success" 
                style="width: 20em; font-weight: 500; background-color: #38946B; margin-bottom: 5em;"
            >
                SUBMIT APPLICATION
            </button>

            <br> 

            <button type="button" class="btn btn-light" (click)="back(currentPage)" style="width: 7em; font-weight: 500;">Back</button>
        </div>

        
             
    </div>
    <div class="right"> 
        <img width="100%" src="/assets/images/content-img.jpg" alt="">
    </div>
</div>